/* tslint:disable */
type QualityGateType =
  'Missing_Shares' |
  'Other_Transaction_Type' |
  'Buy_Transaction_Type' |
  'Missing_Security_Break_Down' |
  'Aggregate_Shares_Validation' |
  'Transaction_Tags' |
  'Duplicate_Filings' |
  'Plan_Action' |
  'Adoption_Missing_dates' |
  'Transaction_Type_null' |
  'Security_Type_null' |
  'Non_Individual_relationship' |
  'Effective_Less_Than_Adoption' |
  'Expiration_Less_Than_Adoption_Or_Effective' |
  'Expiration_And_Duration_Are_Null' |
  'Termination_Less_Than_Adoption' |
  'Expiration_Less_Than_Termination' |
  'Adoption_Less_Than_equals_amendment' |
  'As_Reported_Insider_Null' |
  'Duplicate_Trading_Plan' |
  'PlanLinkage';
module QualityGateType {
  export const MISSING_SHARES: QualityGateType = 'Missing_Shares';
  export const OTHER_TRANSACTION_TYPE: QualityGateType = 'Other_Transaction_Type';
  export const BUY_TRANSACTION_TYPE: QualityGateType = 'Buy_Transaction_Type';
  export const MISSING_SECURITY_BREAK_DOWN: QualityGateType = 'Missing_Security_Break_Down';
  export const AGGREGATE_SHARES_VALIDATION: QualityGateType = 'Aggregate_Shares_Validation';
  export const TRANSACTION_TAGS: QualityGateType = 'Transaction_Tags';
  export const DUPLICATE_FILINGS: QualityGateType = 'Duplicate_Filings';
  export const PLAN_ACTION: QualityGateType = 'Plan_Action';
  export const ADOPTION_MISSING_DATES: QualityGateType = 'Adoption_Missing_dates';
  export const TRANSACTION_TYPE_NULL: QualityGateType = 'Transaction_Type_null';
  export const SECURITY_TYPE_NULL: QualityGateType = 'Security_Type_null';
  export const NON_INDIVIDUAL_RELATIONSHIP: QualityGateType = 'Non_Individual_relationship';
  export const EFFECTIVE_LESS_THAN_ADOPTION: QualityGateType = 'Effective_Less_Than_Adoption';
  export const EXPIRATION_LESS_THAN_ADOPTION_OR_EFFECTIVE: QualityGateType = 'Expiration_Less_Than_Adoption_Or_Effective';
  export const EXPIRATION_AND_DURATION_ARE_NULL: QualityGateType = 'Expiration_And_Duration_Are_Null';
  export const TERMINATION_LESS_THAN_ADOPTION: QualityGateType = 'Termination_Less_Than_Adoption';
  export const EXPIRATION_LESS_THAN_TERMINATION: QualityGateType = 'Expiration_Less_Than_Termination';
  export const ADOPTION_LESS_THAN_EQUALS_AMENDMENT: QualityGateType = 'Adoption_Less_Than_equals_amendment';
  export const AS_REPORTED_INSIDER_NULL: QualityGateType = 'As_Reported_Insider_Null';
  export const DUPLICATE_TRADING_PLAN: QualityGateType = 'Duplicate_Trading_Plan';
  export const PLAN_LINKAGE: QualityGateType = 'PlanLinkage';
  export function values(): QualityGateType[] {
    return [
      MISSING_SHARES,
      OTHER_TRANSACTION_TYPE,
      BUY_TRANSACTION_TYPE,
      MISSING_SECURITY_BREAK_DOWN,
      AGGREGATE_SHARES_VALIDATION,
      TRANSACTION_TAGS,
      DUPLICATE_FILINGS,
      PLAN_ACTION,
      ADOPTION_MISSING_DATES,
      TRANSACTION_TYPE_NULL,
      SECURITY_TYPE_NULL,
      NON_INDIVIDUAL_RELATIONSHIP,
      EFFECTIVE_LESS_THAN_ADOPTION,
      EXPIRATION_LESS_THAN_ADOPTION_OR_EFFECTIVE,
      EXPIRATION_AND_DURATION_ARE_NULL,
      TERMINATION_LESS_THAN_ADOPTION,
      EXPIRATION_LESS_THAN_TERMINATION,
      ADOPTION_LESS_THAN_EQUALS_AMENDMENT,
      AS_REPORTED_INSIDER_NULL,
      DUPLICATE_TRADING_PLAN,
      PLAN_LINKAGE
    ];
  }
}

export { QualityGateType }